import * as React from "react"
const CheckMark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#2E2E2E"
      d="M17.82 2.36a.615.615 0 0 0-.87 0l-9.976 9.975-3.923-3.923a.615.615 0 1 0-.87.87l4.358 4.359c.24.24.63.24.87 0L17.82 3.23c.241-.241.241-.63 0-.871Z"
    />
  </svg>
)
export default CheckMark
